module.exports = __webpack_public_path__ + "static/img/summer class.c58779c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/summer class.png
// module id = 6fyE
// module chunks = 0